import { render, staticRenderFns } from "./LoadVectorControl.vue?vue&type=template&id=73e1520e&scoped=true&lang=pug"
import script from "./LoadVectorControl.vue?vue&type=script&lang=js"
export * from "./LoadVectorControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e1520e",
  null
  
)

export default component.exports